(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ReviewQueue",
                {
                    url: "/ReviewQueue/{queueId}?{transactionId}",
                    component: "reviewQueue",
                    requiredPermissions: [{ AccessObject: "ReviewQueue", ActionType: "Edit" }],
                    resolve: {
                        //applications: ["reviewQueueApi", "$transition$", function (reviewQueueApi, $transition$) {
                        //    return reviewQueueApi.getAllFirelightApplication($transition$.params().queueId);
                        //}]
                        transactions: ["queueApi", "$transition$", function (queueApi, $transition$) {
                            return queueApi.getTransactionsForQueue($transition$.params().queueId);
                        }],
                        user: [
                            "userApi", function (userApi) {
                                return userApi.getCurrentUser();
                            }
                        ],
                        currentTransactionId: ["$stateParams", function ($stateParams) {
                            return $stateParams.transactionId;
                        }]
                    }
                });
        }
    ]);

    app.component("reviewQueue",
        {
            templateUrl: "/App/ReviewQueue/ReviewQueue.html",
            controller: reviewQueueController,
            bindings: {
                transactions: "<",
                user: "<",
                currentTransactionId: "<"
            }
        });

    reviewQueueController.$inject = ["_", "$state", "$mdDialog", "$q", "queueEntryApi", "transactionDocumentApi", "$window", "transactionApi", "queueEntryStates", "$scope", "$timeout", "$filter"];

    function reviewQueueController(_, $state, $mdDialog, $q, queueEntryApi, transactionDocumentApi, $window, transactionApi, queueEntryStates, $scope, $timeout, $filter) {
        var $ctrl = this;       

        this.$state = $state;
        ng.extend($ctrl,
            {
                ui: {},
                approve: approve,
                decline: decline,
                loadFiles: loadFiles,
                upload: upload,
                removeAdditionalDocument: removeAdditionalDocument,
                viewNotes: viewNotes,
                download: download,
                downloadAll: downloadAll
            });

        this.$onInit = function() {
            $ctrl.ui.filterTransactions = _.find(queueEntryStates, function (row) { return row.Value === "Pending"; });

            this.sortOptions = [
                { Label: "Oldest First", Value: "CreatedOn" },
                { Label: "Newest First", Value: "-CreatedOn" }
            ];
            $ctrl.ui.sortTransactions = $ctrl.sortOptions[0];
            //This pages pulls a list of queueEntries that have a nested transaction record.  Now that a queue can be used multiple times as a review queue for the same transaction, what look like duplicates appear on the page. but in reality it's only the separate entries that required approval from the same queue. Below is a work-around for getting the queueEntry approval data to display in a more understandable fashion for if a transactionGroup has 2 or more separate queues for the same transaction, it will 1) log previous approval descriptions transactions that have already been approved by a reviewer in a previous queue entry for that same transaction.  We might look into creating a new record to return to the UI that would contain the Transaction and a list of nexted QueueEntry records, and redo this page to be able to parse that record instead and show the workflows.
           
            var pending = _.filter($ctrl.transactions, function (t) {
                return t.State === "Pending";
            });

            var approved = _.filter($ctrl.transactions, function (t) {
                return t.State === "Approved";
            });

            var waiting = _.filter($ctrl.transactions, function (t) {
                return t.State === "Waiting";
            });

            var declined = _.filter($ctrl.transactions, function (t) {
                return t.State === "Rejected";
            });

            var prevDeclined = _.filter($ctrl.transactions, function (t) {
                return t.State === "PreviousRejection";
            });
            
            ng.forEach(declined, function (d) {
                d.PreviousSameTransactionQueueLog = [];                
                //Add the log descriptions of approval/rejection from an already approved queue entry to the pending queue entry for the same transactionIds)
                ng.forEach(approved, function (a) {                  
                    if (a.TransactionId === d.TransactionId && d.Id !== a.Id) {                     
                        //append approved transaction's description to pending one (so pending will show the previous approval by and times)
                        d.PreviousSameTransactionQueueLog.push($filter('date')(d.StateUpdatedOn, "short") + ' EST - ' + d.StateUpdatedBy.FirstName + ' ' + d.StateUpdatedBy.LastName + ' (' + d.StateUpdatedBy.Email + ') ' + (d.State === 'Rejected' ? 'Declined' : d.State) + ' this transaction');       

                        //out of all the transactions, if there are 2 or more records for same TransactionId because they are in the queue twice for multiple reviews by same transaction group and one is set to declined but some are approved, remove all but declined record from the $ctrl.transactions list as to not be confusing for the user.  
                        var first = _.find($ctrl.transactions, { 'TransactionId': d.TransactionId, 'Id': d.Id });
                        var dupAfterFirstQueueEntryIds = _.map(_.filter($ctrl.transactions, function (t) {
                            return t.TransactionId === first.TransactionId && t.Id !== first.Id;
                        }), "Id");

                        ng.forEach(dupAfterFirstQueueEntryIds, function (d) {
                            var f = _.findIndex($ctrl.transactions, function (t) { return t.Id === d; });
                            if (f !== -1) $ctrl.transactions[f].IsVisible = false;
                        });              
                    }
                });
                ng.forEach(prevDeclined, function (pd) {
                    if (pd.TransactionId === d.TransactionId && d.Id !== pd.Id) {                                              
                        //if one of the entries shows as 'PreviouslyRejected', verify if out of the other declined entries, that the transactionId doesn't match, and hide the previously rejected entry as to not be confusing for the user.  
                        var f = _.findIndex($ctrl.transactions, function (t) { return t.Id === pd.Id; });
                        if (f !== -1) $ctrl.transactions[f].IsVisible = false;
                    }
                });
            });

            ng.forEach(pending, function (p) {
                p.PreviousSameTransactionQueueLog = [];               
                 //Add the log descriptions of approval/rejection from an already approved queue entry to the pending queue entry for the same transactionIds)
                ng.forEach(approved, function (a) {
                    if (a.TransactionId === p.TransactionId) {
                        //append approved transaction's description to pending one (so pending will show the previous approval by and times)
                        p.PreviousSameTransactionQueueLog.push($filter('date')(a.StateUpdatedOn, "short") + ' EST - ' + a.StateUpdatedBy.FirstName + ' ' + a.StateUpdatedBy.LastName + ' (' + a.StateUpdatedBy.Email + ') ' + (a.State === 'Rejected' ? 'Declined' : a.State) + ' this transaction');

                        //out of all the transactions, if there are 2 or more records for same TransactionId because they are in the queue twice for multiple reviews by same transaction group and one is set to pending but some are approved, remove all but pending record from the $ctrl.transactions list as to not be confusing for the user.  
                        var first = _.find($ctrl.transactions, { 'TransactionId': p.TransactionId, 'Id': p.Id });
                        var dupAfterFirstQueueEntryIds = _.map(_.filter($ctrl.transactions, function (t) {
                            return t.TransactionId === first.TransactionId && t.Id !== first.Id;
                        }), "Id");

                        ng.forEach(dupAfterFirstQueueEntryIds, function (d) {
                            var f = _.findIndex($ctrl.transactions, function (t) { return t.Id === d; });
                            if (f !== -1) $ctrl.transactions[f].IsVisible = false;                               
                        });              
                    }
                });               
                ng.forEach(waiting, function (w) {
                    if (w.TransactionId === p.TransactionId) {

                        //out of all the transactions, if there are 2 or more records for same TransactionId because they are in the queue twice for multiple reviews by same transaction group and some are set to waiting but one are pending of same transactionId, remove all but the pending of the records from the $ctrl.transactions list as to not be confusing for the user.
                        var first = _.find($ctrl.transactions, { 'TransactionId': p.TransactionId, 'Id': p.Id });
                        var dupAfterFirstQueueEntryIds = _.map(_.filter($ctrl.transactions, function (t) {
                            return t.TransactionId === first.TransactionId && t.Id !== first.Id;
                        }), "Id");

                        ng.forEach(dupAfterFirstQueueEntryIds, function (d) {
                            var f = _.findIndex($ctrl.transactions, function (t) { return t.Id === d; });
                            if (f !== -1) $ctrl.transactions[f].IsVisible = false;
                        });
                    }
                });
            });

             //Add the log descriptions of approval/rejection from an already approved queue entry to the other approved queue entry for the same transaction)
            ng.forEach(approved, function (a1) {
                a1.PreviousSameTransactionQueueLog = [];
                ng.forEach(approved, function (a2) {
                    if (a2.TransactionId === a1.TransactionId && a2.Id !== a1.Id) {                      
                         //append approved transaction's description to the any other approved one (so they all show the same approval by and times)
                        a1.PreviousSameTransactionQueueLog.push($filter('date')(a2.StateUpdatedOn, "short") + ' EST - ' + a2.StateUpdatedBy.FirstName + ' ' + a2.StateUpdatedBy.LastName + ' (' + a2.StateUpdatedBy.Email + ') ' + (a2.State === 'Rejected' ? 'Declined' : a2.State) + ' this transaction');
                    }
                });               
            });       

            //out of all approved, if there are 2 or more records for same TransactionId because they are in the queue twice for multiple reviews by same transaction group, remove all but one of the records from the $ctrl.transactions list as to not be confusing for the user.  
            var uniqApprovedTrxIds = _.uniq(_.difference(_.map(approved, "TransactionId"), _.map(pending, "TransactionId")));
            ng.forEach(uniqApprovedTrxIds, function (a) {
               
                var first = _.find($ctrl.transactions, { 'TransactionId': a });                       
                var dupAfterFirstQueueEntryIds = _.map(_.filter($ctrl.transactions, function (t) {
                    return t.TransactionId === first.TransactionId && t.Id !== first.Id;
                }), "Id");

                ng.forEach(dupAfterFirstQueueEntryIds, function (d) {
                    var f = _.findIndex($ctrl.transactions, function (t) { return t.Id === d && t.State !== 'Rejected'; });                                      
                    if (f !== -1) $ctrl.transactions[f].IsVisible = false;
                });              
            });

            highlightTransaction();
        };

        this.filterOptions = _.filter(queueEntryStates, function (row) {
            return row.Value === "Pending" ||
                _.find(_.map($ctrl.transactions, "State"),
                    function (r) {
                        return r === row.Value;
                    });
        });

        function approve(transaction) {
            return $mdDialog.show({
                templateUrl: "/App/ReviewQueue/ApproveDeclineTransaction/template.html",
                controller: "approveDeclineTransactionController",
                controllerAs: "$ctrl",
                resolve: {
                    agent: ["agentApi", function (agentApi) {
                        return agentApi.get(transaction.Transaction.PrimaryAgentId);
                    }],
                    transactionGroup: ["userApi", function (userApi) {
                        return userApi.getUserTransactionGroup();
                    }],
                    notes: ["queueEntryApi", function (queueEntryApi) {
                        return queueEntryApi.getNotesForEntry(transaction.Id);
                    }]
                },
                locals: {
                    transaction: transaction,
                    action: "Approve",
                    user: $ctrl.user
                },
                bindToController: true
            });
        }

        function decline(transaction) {
            return $mdDialog.show({
                templateUrl: "/App/ReviewQueue/ApproveDeclineTransaction/template.html",
                controller: "approveDeclineTransactionController",
                controllerAs: "$ctrl",
                resolve: {
                    agent: ["agentApi", function (agentApi) {
                        return agentApi.get(transaction.Transaction.PrimaryAgentId);
                    }],
                    transactionGroup: ["userApi", function (userApi) {
                        return userApi.getUserTransactionGroup();
                    }],
                    notes: ["queueEntryApi", function (queueEntryApi) {
                        return queueEntryApi.getNotesForEntry(transaction.Id);
                    }]
                },
                locals: {
                    transaction: transaction,
                    action: "Decline",
                    user: $ctrl.user
                },
                bindToController: true
            });
        };

        function loadFiles(transaction) {
            console.log(transaction);
            if (transaction.showFiles) {
                transaction.loadingFiles = true;

                var promises = [];
                transaction.transactionDocuments = [];
                promises.push(transactionDocumentApi.getTransactionDocuments(transaction.TransactionId).then(function (docs) {
                    if (docs.length > 0) {
                        transaction.transactionDocuments = docs;
                    }
                }));

                promises.push(transactionApi.getAuditLogFileExists(transaction.TransactionId)
                    .then(function (auditLog) {
                        console.log("AuditLogExists", auditLog);
                        if (!!auditLog && auditLog === true) {
                            transactionApi.getAuditLogFile(transaction.TransactionId)
                                .then(function (response) {
                                    console.log("AuditLog", response);
                                    transaction.transactionDocuments.push({
                                        RequiredFileName: "Audit Log",
                                        Id: "auditLog"
                                    });
                                });
                        }
                    })
                );

                promises.push(transactionApi.getSummaryExists(transaction.TransactionId).then(function (summary) {
                    if (summary !== null && summary === true) {
                        transaction.transactionDocuments.push({
                            RequiredFileName: "Summary",
                            Id: "summary"
                        });
                    }
                }));

                promises.push(transactionApi.getTransactionRightBridgeResponseWithDocuments(transaction.TransactionId).then(function (rightBridgeResponse) {
                    if (rightBridgeResponse !== null && rightBridgeResponse.Documents.length > 0) {
                        transaction.transactionDocuments.push({
                            RequiredFileName: "RightBRIDGE",
                            Id: "rightbridge"
                        });
                    }
                }));

                promises.push(transactionApi.getTransactionRetireUpResponse(transaction.TransactionId).then(function (retireUpResponse) {
                    if (retireUpResponse !== null && retireUpResponse.Documents.length > 0) {
                        transaction.transactionDocuments.push({
                            RequiredFileName: "RetireUp Pro",
                            Id: "retireup"
                        });
                    }
                }));

                $q.all(promises).then(function () {
                    return transaction.loadingFiles = false;
                }, function () {
                    return transaction.loadingFiles = false;
                });
            }

            return transaction.loadingFiles = false;
        };

        function upload(file, transaction) {
            var payload = new FormData();
            payload.append("additionalDocument", file, file.name);

            transactionDocumentApi.addAdditionalDocument(transaction.TransactionId, payload, "AdditionalDocument").then(function (doc) {
                var objectUrls = [];
                transactionDocumentApi.get(transaction.TransactionId, doc.Id)
                    .then(function (url) {
                        var fUrl = window.URL.createObjectURL(url);
                        doc.FileUrl = fUrl;
                        objectUrls.push(fUrl);
                        transaction.transactionDocuments.push(doc);
                    });

                $scope.$on("$destroy",
                    function () {
                        ng.forEach(objectUrls, function (url) { URL.revokeObjectURL(url) });
                    });
            });
        };

        function removeAdditionalDocument(transactionId, transactionDocumentId) {
            transactionDocumentApi.deleteAdditionalDocument(transactionId, transactionDocumentId);
        };

        function viewNotes(queueEntry) {
            return $state.go("Home.ReviewQueue.Notes", { queueEntryId: queueEntry.Id, transaction: queueEntry.Transaction });
        }
        function download(transaction, file) {

            if (file.Id === "summary") {
                $window.open(transactionApi.getSummaryUrl(transaction.TransactionId));
            }
            else if (file.Id === "auditLog") {
                $window.open(transactionApi.getAuditLogFileUrl(transaction.TransactionId));
            }
            else if (file.Id === "rightbridge") {
                transactionApi.getTransactionRightBridgeResponseWithDocuments(transaction.TransactionId).then(function (rightBridgeResponse) {
                    ng.forEach(rightBridgeResponse.Documents, function (x) {
                        (function (doc) {
                            $window.open(transactionApi.getRightBridgeTransactionDocumentUrl(transaction.TransactionId, rightBridgeResponse.Id, doc.FileName));
                        })(x);
                    });
                });
            }

            else if (file.Id === "retireup") {
                transactionApi.getTransactionRetireUpResponse(transaction.TransactionId).then(function (retireUpResponse) {
                    ng.forEach(retireUpResponse.Documents, function (x) {
                        (function (doc) {
                            $window.open(transactionApi.getRightBridgeTransactionDocumentUrl(transaction.TransactionId, retireUpResponse.Id, doc.FileName));
                        })(x);
                    });
                });
            }

            else if (file.Id) {
                $window.open(transactionDocumentApi.getUrl(transaction.TransactionId, file.Id));
            }
        }

        function downloadAll(transaction) {

            ng.forEach(transaction.transactionDocuments, function (file) {
                download(transaction, file);
            });
        }

        function highlightTransaction() {
            if ($ctrl.currentTransactionId) {
                var transaction = _.find($ctrl.transactions,
                    function (row) {
                        return row.Transaction.Id === $ctrl.currentTransactionId;
                    });
                transaction.showFiles = true;
                $ctrl.loadFiles(transaction);
                if (transaction.State !== "Pending")
                    $ctrl.ui.filterTransactions = null;
            }
        }

    }

    fileViewerCtrl.$inject = ["$mdDialog"];
    function fileViewerCtrl($mdDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                close: close
            });

        function close() { $mdDialog.cancel(); };
    };

})(window.app, window.angular);